import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    // getPatientBasicInfo(seqPatient) {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/patient/getPatientBasicInfo';
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //
    //         const data = {
    //             seqManager: auth.seqManager
    //         };
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
    //             .then(res => {
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // },
    appendPatientStatus: function (data) {
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/appendPatientStatus';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    updatePatientInfo: function (data) {

        return new Promise((resolve, reject) => {
            const url = _API + '/patient/updatePatientInfo';
            const conf = {
                headers: _HEADER()
            };

            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    deleteStatusItemFromServer: function (data) {
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/removePatientStatus';
            const conf = {
                headers: _HEADER()
            };
            const inputData = {
                seqPatientStatus: data
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, inputData, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    addPatient(data) { //환자 등록
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/addPatient';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    addPatientNoAuth(data) { //환자 등록 [임시] 인증코드 불필요
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/addPatient/noAuth';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // deletePatientList(data) {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/medicalRelation/removeMedicalRelationBySeqPatient';
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
    //             .then(res => {
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // },
    getPatientStatusListFromServerBySeqMedicalRelation(seqMedicalRelation) {
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/getPatientStatusListFromServerBySeqMedicalRelation';
            const conf = {
                headers: _HEADER()
            };
            const data = {seqMedicalRelation};
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    changeActivationStatus(seqMedicalRelation, isEnabled) {
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/changeActivationStatus';
            const conf = {
                headers: _HEADER()
            };
            const data = {seqMedicalRelation, isEnabled};
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // disableAllUnscheduledPatients() {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/patient/disableAllUnscheduledPatients';
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //         const data = {};
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
    //             .then(res => {
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // },
    isPatientSyncAuthCodeValid(patientSyncAuthCode) {
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/isPatientSyncAuthCodeValid';
            const conf = {
                headers: _HEADER()
            };
            const data = {patientSyncAuthCode};
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
}